import {apiWithToken} from '../../systems/api/index';
import {API_URL} from './../../systems/globalContant';

export default {
    getFeatures: (filters = {})=> apiWithToken.get(API_URL.GET_LIST_FEATURES,  {params: filters}, {loading: false})
}
